import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { API, authHeaders } from '../api';
import Layout from './Layout';
import { ui, statusBadge } from '../ui';
import { colors } from '../theme';
import DataTable from '../components/DataTable';
import { getRole } from '../auth';
import { STATUS_LABEL } from '../statusLabels';

function fmt(str) {
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function Matches() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const isAdmin = getRole() === 'super_admin';
  const profilePath = isAdmin ? '/applications' : '/clients';

  const fetchItems = useCallback(() => {
    axios.get(`${API}/${isAdmin ? 'admin' : 'curator'}/matches`, { headers: authHeaders() })
      .then(r => setItems(r.data));
  }, [isAdmin]);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  const renderUser = (u) => {
    const [bg, fg] = statusBadge[u.status] || [colors.surface2, colors.textMuted];
    return (
      <span
        onClick={(e) => { e.stopPropagation(); navigate(`${profilePath}?open=${u.id}`); }}
        style={{ cursor: 'pointer' }}
      >
        {u.first_name || '—'} ({u.phone}){' '}
        <span style={ui.badge(bg, fg)}>{STATUS_LABEL[u.status] || u.status}</span>
      </span>
    );
  };

  return (
    <Layout>
      <h1 style={ui.title}>Метчи</h1>
      <p style={{ color: colors.textMuted, fontSize: 13, marginTop: -10, marginBottom: 20 }}>
        Только сам факт метча — кто кого лайкнул, отклонил или оставил подумать, остаётся конфиденциальным.
        Клик по пользователю открывает его анкету.
      </p>
      <div style={ui.card}>
        <DataTable
          rows={items}
          rowKey={m => m.id}
          emptyText="Метчей пока нет"
          columns={[
            { key: 'user_a', label: 'Первый', sortValue: m => m.user_a.first_name || '', render: m => renderUser(m.user_a) },
            { key: 'user_b', label: 'Второй', sortValue: m => m.user_b.first_name || '', render: m => renderUser(m.user_b) },
            { key: 'matched_at', label: 'Дата метча', render: m => fmt(m.matched_at) },
          ]}
        />
      </div>
    </Layout>
  );
}
